export type JoinType =
  | 'article'
  | 'forum'
  | 'industry-comparison'
  | 'intro'
  | 'join'
  | 'nil'
  | 'profile'
  | 'rankings'
  | 'recruits'
  | 'settings'
  | 'top-of-content'
  | 'transfer-portal'
  | 'vitals'
  | 'winback';

const countries = [
  { code: 'US', name: 'United States', postalCodeRequired: true },
  { code: 'CA', name: 'Canada', postalCodeRequired: true },
  { code: 'VI', name: 'U.S. Virgin Islands', postalCodeRequired: true },
  { code: 'GB', name: 'United Kingdom', postalCodeRequired: true },
  { code: 'AE', name: 'United Arab Emirates', postalCodeRequired: true },
  { code: 'AC', name: 'Ascension Island', postalCodeRequired: false },
  { code: 'AD', name: 'Andorra', postalCodeRequired: false },
  { code: 'AF', name: 'Afghanistan', postalCodeRequired: false },
  { code: 'AG', name: 'Antigua and Barbuda', postalCodeRequired: false },
  { code: 'AI', name: 'Anguilla', postalCodeRequired: false },
  { code: 'AL', name: 'Albania', postalCodeRequired: false },
  { code: 'AM', name: 'Armenia', postalCodeRequired: false },
  { code: 'AO', name: 'Angola', postalCodeRequired: false },
  { code: 'AQ', name: 'Antarctica', postalCodeRequired: false },
  { code: 'AR', name: 'Argentina', postalCodeRequired: false },
  { code: 'AS', name: 'American Samoa', postalCodeRequired: false },
  { code: 'AT', name: 'Austria', postalCodeRequired: false },
  { code: 'AU', name: 'Australia', postalCodeRequired: false },
  { code: 'AW', name: 'Aruba', postalCodeRequired: false },
  { code: 'AX', name: 'Åland Islands', postalCodeRequired: false },
  { code: 'AZ', name: 'Azerbaijan', postalCodeRequired: false },
  { code: 'BA', name: 'Bosnia and Herzegovina', postalCodeRequired: false },
  { code: 'BB', name: 'Barbados', postalCodeRequired: false },
  { code: 'BD', name: 'Bangladesh', postalCodeRequired: false },
  { code: 'BE', name: 'Belgium', postalCodeRequired: false },
  { code: 'BF', name: 'Burkina Faso', postalCodeRequired: false },
  { code: 'BG', name: 'Bulgaria', postalCodeRequired: false },
  { code: 'BH', name: 'Bahrain', postalCodeRequired: false },
  { code: 'BI', name: 'Burundi', postalCodeRequired: false },
  { code: 'BJ', name: 'Benin', postalCodeRequired: false },
  { code: 'BL', name: 'Saint Barthélemy', postalCodeRequired: false },
  { code: 'BM', name: 'Bermuda', postalCodeRequired: false },
  { code: 'BN', name: 'Brunei', postalCodeRequired: false },
  { code: 'BO', name: 'Bolivia', postalCodeRequired: false },
  { code: 'BR', name: 'Brazil', postalCodeRequired: false },
  { code: 'BS', name: 'Bahamas', postalCodeRequired: false },
  { code: 'BT', name: 'Bhutan', postalCodeRequired: false },
  { code: 'BV', name: 'Bouvet Island', postalCodeRequired: false },
  { code: 'BW', name: 'Botswana', postalCodeRequired: false },
  { code: 'BY', name: 'Belarus', postalCodeRequired: false },
  { code: 'BZ', name: 'Belize', postalCodeRequired: false },
  { code: 'CC', name: 'Cocos [Keeling] Islands', postalCodeRequired: false },
  {
    code: 'CD',
    name: 'Congo [Democratic Republic]',
    postalCodeRequired: false,
  },
  { code: 'CF', name: 'Central African Republic', postalCodeRequired: false },
  { code: 'CG', name: 'Congo [Republic]', postalCodeRequired: false },
  { code: 'CH', name: 'Switzerland', postalCodeRequired: false },
  { code: 'CI', name: 'Côte d’Ivoire', postalCodeRequired: false },
  { code: 'CK', name: 'Cook Islands', postalCodeRequired: false },
  { code: 'CL', name: 'Chile', postalCodeRequired: false },
  { code: 'CM', name: 'Cameroon', postalCodeRequired: false },
  { code: 'CN', name: 'China', postalCodeRequired: false },
  { code: 'CO', name: 'Colombia', postalCodeRequired: false },
  { code: 'CR', name: 'Costa Rica', postalCodeRequired: false },
  { code: 'CU', name: 'Cuba', postalCodeRequired: false },
  { code: 'CV', name: 'Cabo Verde', postalCodeRequired: false },
  { code: 'CX', name: 'Christmas Island', postalCodeRequired: false },
  { code: 'CY', name: 'Cyprus', postalCodeRequired: false },
  { code: 'CZ', name: 'Czech Republic', postalCodeRequired: false },
  { code: 'DE', name: 'Germany', postalCodeRequired: false },
  { code: 'DG', name: 'Diego Garcia', postalCodeRequired: false },
  { code: 'DJ', name: 'Djibouti', postalCodeRequired: false },
  { code: 'DK', name: 'Denmark', postalCodeRequired: false },
  { code: 'DM', name: 'Dominica', postalCodeRequired: false },
  { code: 'DO', name: 'Dominican Republic', postalCodeRequired: false },
  { code: 'DZ', name: 'Algeria', postalCodeRequired: false },
  { code: 'EC', name: 'Ecuador', postalCodeRequired: false },
  { code: 'EE', name: 'Estonia', postalCodeRequired: false },
  { code: 'EG', name: 'Egypt', postalCodeRequired: false },
  { code: 'EH', name: 'Western Sahara', postalCodeRequired: false },
  { code: 'ER', name: 'Eritrea', postalCodeRequired: false },
  { code: 'ES', name: 'Spain', postalCodeRequired: false },
  { code: 'ET', name: 'Ethiopia', postalCodeRequired: false },
  { code: 'FI', name: 'Finland', postalCodeRequired: false },
  { code: 'FJ', name: 'Fiji', postalCodeRequired: false },
  { code: 'FK', name: 'Falkland Islands', postalCodeRequired: false },
  { code: 'FM', name: 'Micronesia', postalCodeRequired: false },
  { code: 'FO', name: 'Faroe Islands', postalCodeRequired: false },
  { code: 'FR', name: 'France', postalCodeRequired: false },
  { code: 'GA', name: 'Gabon', postalCodeRequired: false },
  { code: 'GD', name: 'Grenada', postalCodeRequired: false },
  { code: 'GE', name: 'Georgia', postalCodeRequired: false },
  { code: 'GF', name: 'French Guiana', postalCodeRequired: false },
  { code: 'GG', name: 'Guernsey', postalCodeRequired: false },
  { code: 'GH', name: 'Ghana', postalCodeRequired: false },
  { code: 'GI', name: 'Gibraltar', postalCodeRequired: false },
  { code: 'GL', name: 'Greenland', postalCodeRequired: false },
  { code: 'GM', name: 'Gambia', postalCodeRequired: false },
  { code: 'GN', name: 'Guinea', postalCodeRequired: false },
  { code: 'GP', name: 'Guadeloupe', postalCodeRequired: false },
  { code: 'GQ', name: 'Equatorial Guinea', postalCodeRequired: false },
  { code: 'GR', name: 'Greece', postalCodeRequired: false },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    postalCodeRequired: false,
  },
  { code: 'GT', name: 'Guatemala', postalCodeRequired: false },
  { code: 'GU', name: 'Guam', postalCodeRequired: false },
  { code: 'GW', name: 'Guinea-Bissau', postalCodeRequired: false },
  { code: 'GY', name: 'Guyana', postalCodeRequired: false },
  { code: 'HK', name: 'Hong Kong', postalCodeRequired: false },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
    postalCodeRequired: false,
  },
  { code: 'HN', name: 'Honduras', postalCodeRequired: false },
  { code: 'HR', name: 'Croatia', postalCodeRequired: false },
  { code: 'HT', name: 'Haiti', postalCodeRequired: false },
  { code: 'HU', name: 'Hungary', postalCodeRequired: false },
  { code: 'ID', name: 'Indonesia', postalCodeRequired: false },
  { code: 'IE', name: 'Ireland', postalCodeRequired: false },
  { code: 'IL', name: 'Israel', postalCodeRequired: false },
  { code: 'IM', name: 'Isle of Man', postalCodeRequired: false },
  { code: 'IN', name: 'India', postalCodeRequired: false },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    postalCodeRequired: false,
  },
  { code: 'IQ', name: 'Iraq', postalCodeRequired: false },
  { code: 'IR', name: 'Iran', postalCodeRequired: false },
  { code: 'IS', name: 'Iceland', postalCodeRequired: false },
  { code: 'IT', name: 'Italy', postalCodeRequired: false },
  { code: 'JE', name: 'Jersey', postalCodeRequired: false },
  { code: 'JM', name: 'Jamaica', postalCodeRequired: false },
  { code: 'JO', name: 'Jordan', postalCodeRequired: false },
  { code: 'JP', name: 'Japan', postalCodeRequired: false },
  { code: 'KE', name: 'Kenya', postalCodeRequired: false },
  { code: 'KG', name: 'Kyrgyzstan', postalCodeRequired: false },
  { code: 'KH', name: 'Cambodia', postalCodeRequired: false },
  { code: 'KI', name: 'Kiribati', postalCodeRequired: false },
  { code: 'KM', name: 'Comoros', postalCodeRequired: false },
  { code: 'KN', name: 'Saint Kitts and Nevis', postalCodeRequired: false },
  { code: 'KP', name: 'North Korea', postalCodeRequired: false },
  { code: 'KR', name: 'South Korea', postalCodeRequired: false },
  { code: 'KW', name: 'Kuwait', postalCodeRequired: false },
  { code: 'KY', name: 'Cayman Islands', postalCodeRequired: false },
  { code: 'KZ', name: 'Kazakhstan', postalCodeRequired: false },
  { code: 'LA', name: 'Laos', postalCodeRequired: false },
  { code: 'LB', name: 'Lebanon', postalCodeRequired: false },
  { code: 'LC', name: 'Saint Lucia', postalCodeRequired: false },
  { code: 'LI', name: 'Liechtenstein', postalCodeRequired: false },
  { code: 'LK', name: 'Sri Lanka', postalCodeRequired: false },
  { code: 'LR', name: 'Liberia', postalCodeRequired: false },
  { code: 'LS', name: 'Lesotho', postalCodeRequired: false },
  { code: 'LT', name: 'Lithuania', postalCodeRequired: false },
  { code: 'LU', name: 'Luxembourg', postalCodeRequired: false },
  { code: 'LV', name: 'Latvia', postalCodeRequired: false },
  { code: 'LY', name: 'Libya', postalCodeRequired: false },
  { code: 'MA', name: 'Morocco', postalCodeRequired: false },
  { code: 'MC', name: 'Monaco', postalCodeRequired: false },
  { code: 'MD', name: 'Moldova', postalCodeRequired: false },
  { code: 'ME', name: 'Montenegro', postalCodeRequired: false },
  { code: 'MF', name: 'Saint Martin', postalCodeRequired: false },
  { code: 'MG', name: 'Madagascar', postalCodeRequired: false },
  { code: 'MH', name: 'Marshall Islands', postalCodeRequired: false },
  { code: 'MK', name: 'North Macedonia', postalCodeRequired: false },
  { code: 'ML', name: 'Mali', postalCodeRequired: false },
  { code: 'MM', name: 'Myanmar [Burma]', postalCodeRequired: false },
  { code: 'MN', name: 'Mongolia', postalCodeRequired: false },
  { code: 'MO', name: 'Macao', postalCodeRequired: false },
  { code: 'MP', name: 'Northern Mariana Islands', postalCodeRequired: false },
  { code: 'MQ', name: 'Martinique', postalCodeRequired: false },
  { code: 'MR', name: 'Mauritania', postalCodeRequired: false },
  { code: 'MS', name: 'Montserrat', postalCodeRequired: false },
  { code: 'MT', name: 'Malta', postalCodeRequired: false },
  { code: 'MU', name: 'Mauritius', postalCodeRequired: false },
  { code: 'MV', name: 'Maldives', postalCodeRequired: false },
  { code: 'MW', name: 'Malawi', postalCodeRequired: false },
  { code: 'MX', name: 'Mexico', postalCodeRequired: false },
  { code: 'MY', name: 'Malaysia', postalCodeRequired: false },
  { code: 'MZ', name: 'Mozambique', postalCodeRequired: false },
  { code: 'NA', name: 'Namibia', postalCodeRequired: false },
  { code: 'NC', name: 'New Caledonia', postalCodeRequired: false },
  { code: 'NE', name: 'Niger', postalCodeRequired: false },
  { code: 'NF', name: 'Norfolk Island', postalCodeRequired: false },
  { code: 'NG', name: 'Nigeria', postalCodeRequired: false },
  { code: 'NI', name: 'Nicaragua', postalCodeRequired: false },
  { code: 'NL', name: 'Netherlands', postalCodeRequired: false },
  { code: 'NO', name: 'Norway', postalCodeRequired: false },
  { code: 'NP', name: 'Nepal', postalCodeRequired: false },
  { code: 'NR', name: 'Nauru', postalCodeRequired: false },
  { code: 'NU', name: 'Niue', postalCodeRequired: false },
  { code: 'NZ', name: 'New Zealand', postalCodeRequired: false },
  { code: 'OM', name: 'Oman', postalCodeRequired: false },
  { code: 'PA', name: 'Panama', postalCodeRequired: false },
  { code: 'PE', name: 'Peru', postalCodeRequired: false },
  { code: 'PF', name: 'French Polynesia', postalCodeRequired: false },
  { code: 'PG', name: 'Papua New Guinea', postalCodeRequired: false },
  { code: 'PH', name: 'Philippines', postalCodeRequired: false },
  { code: 'PK', name: 'Pakistan', postalCodeRequired: false },
  { code: 'PL', name: 'Poland', postalCodeRequired: false },
  { code: 'PM', name: 'Saint Pierre and Miquelon', postalCodeRequired: false },
  { code: 'PN', name: 'Pitcairn Islands', postalCodeRequired: false },
  { code: 'PR', name: 'Puerto Rico', postalCodeRequired: false },
  { code: 'PS', name: 'Palestinian Territories', postalCodeRequired: false },
  { code: 'PT', name: 'Portugal', postalCodeRequired: false },
  { code: 'PW', name: 'Palau', postalCodeRequired: false },
  { code: 'PY', name: 'Paraguay', postalCodeRequired: false },
  { code: 'QA', name: 'Qatar', postalCodeRequired: false },
  { code: 'RE', name: 'Réunion', postalCodeRequired: false },
  { code: 'RO', name: 'Romania', postalCodeRequired: false },
  { code: 'RS', name: 'Serbia', postalCodeRequired: false },
  { code: 'RU', name: 'Russia', postalCodeRequired: false },
  { code: 'RW', name: 'Rwanda', postalCodeRequired: false },
  { code: 'SA', name: 'Saudi Arabia', postalCodeRequired: false },
  { code: 'SB', name: 'Solomon Islands', postalCodeRequired: false },
  { code: 'SC', name: 'Seychelles', postalCodeRequired: false },
  { code: 'SD', name: 'Sudan', postalCodeRequired: false },
  { code: 'SE', name: 'Sweden', postalCodeRequired: false },
  { code: 'SG', name: 'Singapore', postalCodeRequired: false },
  { code: 'SH', name: 'Saint Helena', postalCodeRequired: false },
  { code: 'SI', name: 'Slovenia', postalCodeRequired: false },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', postalCodeRequired: false },
  { code: 'SK', name: 'Slovakia', postalCodeRequired: false },
  { code: 'SL', name: 'Sierra Leone', postalCodeRequired: false },
  { code: 'SM', name: 'San Marino', postalCodeRequired: false },
  { code: 'SN', name: 'Senegal', postalCodeRequired: false },
  { code: 'SO', name: 'Somalia', postalCodeRequired: false },
  { code: 'SR', name: 'Suriname', postalCodeRequired: false },
  { code: 'SS', name: 'South Sudan', postalCodeRequired: false },
  { code: 'ST', name: 'São Tomé and Príncipe', postalCodeRequired: false },
  { code: 'SV', name: 'El Salvador', postalCodeRequired: false },
  { code: 'SX', name: 'Sint Maarten [Dutch part]', postalCodeRequired: false },
  { code: 'SY', name: 'Syria', postalCodeRequired: false },
  { code: 'SZ', name: 'Swaziland', postalCodeRequired: false },
  { code: 'TC', name: 'Turks and Caicos Islands', postalCodeRequired: false },
  { code: 'TD', name: 'Chad', postalCodeRequired: false },
  {
    code: 'TF',
    name: 'French Southern Territories',
    postalCodeRequired: false,
  },
  { code: 'TG', name: 'Togo', postalCodeRequired: false },
  { code: 'TH', name: 'Thailand', postalCodeRequired: false },
  { code: 'TJ', name: 'Tajikistan', postalCodeRequired: false },
  { code: 'TK', name: 'Tokelau', postalCodeRequired: false },
  { code: 'TL', name: 'Timor-Leste', postalCodeRequired: false },
  { code: 'TM', name: 'Turkmenistan', postalCodeRequired: false },
  { code: 'TN', name: 'Tunisia', postalCodeRequired: false },
  { code: 'TO', name: 'Tonga', postalCodeRequired: false },
  { code: 'TR', name: 'Turkey', postalCodeRequired: false },
  { code: 'TT', name: 'Trinidad and Tobago', postalCodeRequired: false },
  { code: 'TV', name: 'Tuvalu', postalCodeRequired: false },
  { code: 'TW', name: 'Taiwan', postalCodeRequired: false },
  { code: 'TZ', name: 'Tanzania', postalCodeRequired: false },
  { code: 'UA', name: 'Ukraine', postalCodeRequired: false },
  { code: 'UG', name: 'Uganda', postalCodeRequired: false },
  {
    code: 'UM',
    name: 'U.S. Minor Outlying Islands',
    postalCodeRequired: false,
  },
  { code: 'UY', name: 'Uruguay', postalCodeRequired: false },
  { code: 'UZ', name: 'Uzbekistan', postalCodeRequired: false },
  { code: 'VA', name: 'Vatican City', postalCodeRequired: false },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    postalCodeRequired: false,
  },
  { code: 'VE', name: 'Venezuela', postalCodeRequired: false },
  { code: 'VG', name: 'British Virgin Islands', postalCodeRequired: false },
  { code: 'VN', name: 'Vietnam', postalCodeRequired: false },
  { code: 'VU', name: 'Vanuatu', postalCodeRequired: false },
  { code: 'WF', name: 'Wallis and Futuna', postalCodeRequired: false },
  { code: 'WS', name: 'Samoa', postalCodeRequired: false },
  { code: 'YE', name: 'Yemen', postalCodeRequired: false },
  { code: 'YT', name: 'Mayotte', postalCodeRequired: false },
  { code: 'ZA', name: 'South Africa', postalCodeRequired: false },
  { code: 'ZM', name: 'Zambia', postalCodeRequired: false },
  { code: 'ZW', name: 'Zimbabwe', postalCodeRequired: false },
];

const formatCurrency = (amount: string | number, currency: string = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  }).format(Number(amount));
};

export { countries, formatCurrency };
